export default __webpack_public_path__ + "static/media/2019_full.be08ff94.jpg";